import useThemeStore from "(store)/themeStore";
import * as Forms from "components/forms";
import * as Icons from "assets/svg";
import { Link } from "react-router";
import "styles/AuthScreens.css";

const Login = () => {
  const theme = useThemeStore((state) => state.theme);

  return (
    <div className="max-w-full">
      <div className="min-h-full min-w-full">
        <div className="min-h-screen bg-auth-Bg dark:bg-auth-dark-Bg bg-no-repeat bg-center bg-cover bg-fixed flex flex-col justify-center items-center">
          <div className="hidden sm:flex items-center flex-col">
            <div className="pt-2">
              <Icons.Logo
                width={"4em"}
                height={"5em"}
              />
            </div>
            <div className="pt-5 px-2">
              <p className="text-[2rem] text-center">
                <span className="text-[#1467b0] dark:text-white">
                  Spade Rent Admin
                </span>{" "}
                Login
              </p>
            </div>
            <hr className="md:border-t-[3px] md:w-72 md:border-orange-300 rounded-full" />
            <div>
              <p className="lg:text-[2.8rem] text-4xl font-bold py-6 px-2 text-center">
                Elevate Your{" "}
                <span className="text-[#1467b0] dark:md:text-white">
                  Portfolio
                </span>{" "}
              </p>
            </div>
            <div className="w-full sm:w-[530px] flex justify-center pb-4 px-4 text-center">
              <p className="text-[1rem]">
                Streamline your property management tasks with ease. Experience
                the future of real estate management today
              </p>
            </div>
          </div>

          <div className="w-full flex justify-center items-center px-2.5 min-h-screen sm:min-h-full">
            <div
              className={`w-full sm:w-[600px] sm:mb-10 py-10 px-5 sm:px-10 ${
                theme === "dark" ? "auth-card-dark" : "auth-card"
              } rounded-lg transition duration-300 ease-in-out`}>
              <div className="text-center">
                <span className="flex justify-center dark:hidden">
                  <Icons.LogoRent
                    width="150px"
                    height="73.25px"
                  />
                </span>
                <span className="hidden justify-center dark:flex">
                  <Icons.LogoRentWhite
                    width="150px"
                    height="73.25px"
                  />
                </span>
              </div>
              <div className="flex justify-center mb-2">
                <p className="text-[32px] font-normal dark:text-white">
                  Welcome{" "}
                  <span className="font-bold text-[#1467b0]">Back!</span>
                </p>
              </div>
              <div className="flex justify-center">
                <p className="text-xs font-medium dark:text-white">
                  Please enter your credentials to sign in to your account
                </p>
              </div>
              <Forms.LoginForm />
              <div className="flex items-center justify-center mt-5">
                <p className="text-[#1467b0] text-sm font-bold">
                  <Link to="#">Spade, LLC</Link>{" "}
                  <span className="text-black dark:text-white">
                    &copy; 2024 - {new Date().getFullYear()}
                  </span>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
